import { useEffect } from 'react';
import { Route, Routes, useLocation, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Footer } from '@a-ui/react';
import { fetchInbox, registerNotificationToken } from './store/slices/notificationReducer';
import { fetchUser } from './store/slices/userReducer';
import { requestLocation } from './store/slices/locationReducer';
import { listenForNotifications, requestNotifications } from './helpers/notifications.helper';
import Header from './components/Header/Header';
import Modal from './components/Modal/Modal';
import Login from './components/Login/Login';
import Home from './components/Home/Home';
import Task from './components/Task/Task';
import Alerts from './components/Alerts/Alerts';
import Carrousel from './components/Carrousel/Carrousel';
import NotificationsBell from './components/Notifications/NotificationsBell';
import UserMenu from './components/UserMenu/UserMenu';

import './App.scss';

function App(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()
  const { user, isLoggedin, socket } = useSelector(state => state.user);
  const { notificationsRequested } = useSelector(state => state.notifications);

  useEffect(() => {
    dispatch(fetchInbox());
    dispatch(fetchUser());
    // dispatch(fetchUserSocket());
    dispatch(requestLocation());
  }, [dispatch]);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", message => {
        if (message.data.type === "NOTIFICATION_CLICK") {
          navigate(message.data.path);
        }
      });
      // register this device to recieve notifications
      if ("Notification" in window && Notification.permission === "granted" && user && user.id) {
        requestNotifications().then(({ activate, token }) => {
          dispatch(registerNotificationToken(token));
        });
      }
    }
  // eslint-disable-next-line
  }, [ user ]);

  useEffect(() => {
    if(user && navigate && socket) {
      const websocket = listenForNotifications(user, socket, navigate, dispatch);
      return () => {
        if(websocket?.disconnect) {
          websocket.disconnect();
        }
      };
    }
  }, [socket, user, navigate, notificationsRequested, dispatch]);

  if(!isLoggedin && location.pathname !== "/login") {
    return <Navigate to={`/login?from=${location.pathname}`}  replace={true} />
  }

  return (
    <div className="App">
      <header>
        <Header logoAlt="Antwerpen logo." logoSrc="https://cdn.antwerpen.be/core_branding_scss/6.4.0/assets/images/a-logo.svg">
          <div className="o-header__content-wrapper">
            <div className="o-header__menu-items">
              <div className="o-header__menu-items">
                {
                  isLoggedin &&
                  <div className="notifications-menu-icon">
                    <NotificationsBell />
                  </div>
                }
              </div>
              <div className="o-header__menu-item o-header__user-menu">
                <UserMenu
                  user={user}
                  loggedIn={isLoggedin}
                  loginUrl="/auth/login/mprofiel"
                  logoutUrl="/auth/logout/mprofiel"
                />
              </div>
            </div>
          </div>
        </Header>
      </header>
      <div className="main">
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/task/:taskId" element={<Task/>} />
          <Route path="/taak/:taskId" element={<Task/>} />
          <Route path="/login" element={<Login/>}></Route>
        </Routes>
      </div>
      <footer>
        <Footer items={[{"label": "© stad Antwerpen"}]} backToTop={true} />
      </footer>
      <Alerts/>
      <Carrousel/>
      <Modal/>
    </div>
  );
}

export default App;
